import React, {ReactDom, Component} from 'react';
import Modal from 'react-modal';
import Icon from './Icon.js';

import './BioPedModal.css';
import { SanitizeClassNames } from '../common.js';
import ColorHelper from "../classes/ColorHelper";

Modal.setAppElement('#root');

export default class BiopedModal extends Component{

	componentDidMount() {
		if(this.props.modalId !== null) {

		}
	}

	render(){
		let styles = {
			overlay: {
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: 'rgba(0, 0, 0, 0.1)'
			},
			'content': {
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				right: 'initial',
				bottom: 'initial',
				border: 'none',
				background: 'none',
				overflow: 'visible',
				WebkitOverflowScrolling: 'touch',
				borderRadius: '0px',
				outline: 'none',
				padding: '0px',
				maxHeight: '100%'
			}
		}

		//console.log("BiopedModal:", this.props);
		let tailStyle = (this.props.tail) ? this.props.tail:{display:'none'};

		let {tail, style, className, ...props} = this.props;

		//let side = this.props.side? <div className="vmax">{this.props.side}</div>: '';

		return(
			<Modal className={ SanitizeClassNames(this, 'bioped-modal') } {...props} style={styles}>

				<div className='table align-top'>
					<div>
						<div>
							<div className='modal-tail' style={tailStyle}>
								<div className='diamond'></div>
							</div>
							<div className="title">{this.props.title}</div>
							<div className="modal-content">{this.props.children}</div>
						</div>
						{this.props.side}
					</div>
				</div>

			</Modal>
		)
	}
}

export class CardModal extends Component{
	render(){
		let cardColor = this.props.color;
		let invColor = ColorHelper.GetInverse(cardColor);
		let modalTitle = <div className="modal-title" style={{backgroundColor: cardColor, color: invColor}}>
			{this.props.title}
			<div className="table align-middle align-center action-btn" onClick={this.props.onActionClick} style={{backgroundColor: cardColor}}>
				<div>
					<div><Icon icon={this.props.actionIcon || 'edit'} /></div>
				</div>
			</div>
		</div>;

		let {title, className, ...props} = this.props;
		return(
			<BiopedModal title={modalTitle} className={ SanitizeClassNames(this, 'card-modal') } {... props}>
				{this.props.children}
			</BiopedModal>
		)
	}
}

export class ActionModal extends Component{

	render(){

		let {title, className, ...props} = this.props;
		let modalTitle = <div className='modal-title table hmax vmax align-middle'>
			<div >
				<div>{this.props.title}</div>
				<div className='align-right'><span className='close-btn' onClick={this.props.onRequestClose}>{this.props.close}</span></div>
			</div>
		</div>;
		return(
			<BiopedModal title={modalTitle} className={ SanitizeClassNames(this, 'action-modal') } {...props}>
				{this.props.children}
			</BiopedModal>
		)
	}
}

export class SideModal extends Component{
	render(){
		let {title, className, ...props} = this.props;
		return(
			<BiopedModal className={ SanitizeClassNames(this, 'side-modal') } {...props}>
				{this.props.children}
			</BiopedModal>
		)
	}
}

export class WarningModal extends Component {
	render(){
		const {title, className, ...props} = this.props;
		return(
			<BiopedModal className={ SanitizeClassNames(this, 'warning-modal') } {...props}>
				{this.props.children}
			</BiopedModal>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/BioPedModal.jsx